import { http, unwrapApiResponse } from './http'
import { clearSession } from '../utils/authSession'

export async function loginByPassword(credentials) {
  const response = await http.post('/v1/users/loginByPassword', credentials)
  return unwrapApiResponse(response)
}

export async function fetchCurrentUser() {
  const response = await http.get('/v1/users/current')
  return unwrapApiResponse(response)
}

export function clearLogin() {
  clearSession()
}

export async function registerAccount(credentials) {
  const response = await http.post('/v1/users/register', credentials)
  return unwrapApiResponse(response)
}
